import React from 'react'
import { IconBaseProps, default as Icon } from 'react-icon-base'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export type StyledIconProps = IconBaseProps

// This is used as a bunker to prevent some legacy styling that affects SVG elements from cascading to the icon SVGs
const bunkerClassName = 'cs-react-icon'

// This is a small "CSS reset" that overrides some legacy SVG styles
// All SVG icons will need to be composed of this stateless component
export function StyledIcon({ className, color, ...props }: StyledIconProps) {
  let colorClassName
  if (color) {
    colorClassName = css`
      color: ${theme.color[color] || color};
    `
  }
  return (
    <Icon
      className={cx(bunkerClassName, className, colorClassName)}
      {...(props as object)}
    />
  )
}
